import { Preferences } from "@capacitor/preferences";
import { FIRST_ORDER_TIPS, type FirstOrderTip } from "@shared/buyerFirstRun";

// Device-local memory of a buyer's first-order guides (shared/buyerFirstRun.ts).
// Native Preferences in the app (it outlives WebView storage purges),
// localStorage on the web. A failed read means "not seen": the worst case is
// one extra showing.

const TIPS_KEY = "fo_first_order_tips_v1";

export async function getSeenFirstOrderTips(): Promise<Set<FirstOrderTip>> {
  try {
    const raw = (await Preferences.get({ key: TIPS_KEY })).value;
    const list: unknown = raw ? JSON.parse(raw) : [];
    return new Set(
      Array.isArray(list)
        ? list.filter((t): t is FirstOrderTip => (FIRST_ORDER_TIPS as readonly string[]).includes(t))
        : [],
    );
  } catch {
    return new Set();
  }
}

export async function setSeenFirstOrderTips(seen: ReadonlySet<FirstOrderTip>): Promise<void> {
  try {
    await Preferences.set({ key: TIPS_KEY, value: JSON.stringify(Array.from(seen)) });
  } catch {
    // Storage unavailable (private window): a guide may show once more.
  }
}
